<script setup lang="ts">
import { toRefs } from "vue";

const props = defineProps({
	label: String,
	state: {
		type: String,
		default: () => "data-source",
	},
	labelAction: {
		type: Function,
		required: false,
	},
	labelIcon: {
		type: String,
		required: false,
	},
});

const { label, state, labelIcon, labelAction } = toRefs(props);
</script>

<template>
	<div :class="state !== 'hidden' ? 'py-10' : 'py-5'">
		<div
			class="px-5 py-5 data-source-group"
			:class="`data-source-group--` + state"
		>
			<div class="label text-caption pl-3 py-1 d-flex">
				<div class="pr-3">{{ label }}</div>
				<div v-if="labelIcon">
					<v-btn
						@click="labelAction()"
						:icon="labelIcon"
						rounded="0"
						class="ma-0 px-3"
						size="20"
						variant="tonal"
						:color="state === 'exclude' ? 'active-secondary' : 'active'"
					></v-btn>
				</div>
			</div>
			<slot></slot>
		</div>
	</div>
</template>

<style scoped lang="scss">
.data-source-group {
	border-radius: 3px;
	position: relative;

	&--data-source {
		border: 1px dashed rgb(202, 204, 212);

		.label {
			background-color: rgb(var(--color-background));
			color: rgba(0, 0, 0, 0.5);
		}
	}

	&--include {
		border: 1px dashed rgba(var(--color-active), 0.3);

		.label {
			background-color: rgba(var(--color-active), 0.1);
			color: rgb(var(--color-active));
		}
	}

	&--exclude {
		border: 1px dashed rgba(var(--color-active-secondary), 0.3);

		.label {
			background-color: rgba(var(--color-active-secondary), 0.1);
			color: rgb(var(--color-active-secondary));
		}
	}

	&--hidden {
		border: 0;
		padding: unset !important;

		.label {
			display: none !important;
		}
	}

	.label {
		position: absolute;
		top: -28px;
		left: 0;
	}
}
</style>
